import { render, staticRenderFns } from "./StaffRegister.vue?vue&type=template&id=273ce8e7&"
import script from "./StaffRegister.vue?vue&type=script&lang=js&"
export * from "./StaffRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports